import { create } from 'zustand';
import { 
  TeamPreferences, 
  SchedulingPreferences,
  NotificationPreferences
} from '@/types/preference';
import { preferenceService } from '@/lib/api/preferenceService';

interface PreferenceState {
  teamPreferences: TeamPreferences | null;
  isLoading: boolean;
  error: string | null;
  
  fetchTeamPreferences: (teamId: string) => Promise<TeamPreferences>;
  updateSchedulingPreferences: (
    teamId: string, 
    preferences: Partial<SchedulingPreferences>
  ) => Promise<TeamPreferences>;
  updateNotificationPreferences: (
    teamId: string, 
    preferences: Partial<NotificationPreferences>
  ) => Promise<TeamPreferences>;
}

export const usePreferenceStore = create<PreferenceState>((set) => ({
  teamPreferences: null,
  isLoading: false,
  error: null,
  
  fetchTeamPreferences: async (teamId: string) => {
    set({ isLoading: true, error: null });
    try {
      const preferences = await preferenceService.getTeamPreferences(teamId);
      set({ teamPreferences: preferences, isLoading: false });
      return preferences;
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'An unknown error occurred', 
        isLoading: false 
      });
      throw error;
    }
  },
  
  updateSchedulingPreferences: async (teamId: string, preferences: Partial<SchedulingPreferences>) => {
    set({ isLoading: true, error: null });
    try {
      const updatedPreferences = await preferenceService.updateTeamPreferences({
        team_id: teamId,
        scheduling_preferences: preferences
      });
      set({ teamPreferences: updatedPreferences, isLoading: false });
      return updatedPreferences;
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'An unknown error occurred', 
        isLoading: false 
      });
      throw error;
    }
  },
  
  updateNotificationPreferences: async (teamId: string, preferences: Partial<NotificationPreferences>) => {
    set({ isLoading: true, error: null });
    try {
      const updatedPreferences = await preferenceService.updateTeamPreferences({
        team_id: teamId,
        notification_preferences: preferences
      });
      set({ teamPreferences: updatedPreferences, isLoading: false });
      return updatedPreferences;
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'An unknown error occurred', 
        isLoading: false 
      });
      throw error;
    }
  }
})); 